import {
  CURRENT_CITY_COOKIE_NAME,
  CURRENT_CITY_COOKIE_MAX_AGE,
} from '@/shared/constants/cookiesConstants';
import { ROOT_CATALOG_URL } from '@/shared/constants/urlConstants';

const CATALOG_PATH_PREFIX = ROOT_CATALOG_URL.replace(/\/$/, '');

export default defineNuxtRouteMiddleware((to) => {
  if (to.path.startsWith(CATALOG_PATH_PREFIX)) return;

  const currentCityCookie = useCookie(CURRENT_CITY_COOKIE_NAME, {
    path: '/',
    maxAge: CURRENT_CITY_COOKIE_MAX_AGE,
  });
  currentCityCookie.value = null;
});
